export interface PostalCodeFormat {
  pattern: RegExp;
  example: string;
  errorMessage: string;
}

export const postalCodeFormats: {[country: string]: PostalCodeFormat} = {
  US: {
    pattern: /^\d{5}(?:[-\s]\d{4})?$/,
    example: `94105`,
    errorMessage: `Please enter a valid US ZIP code.`,
  },
  CA: {
    pattern: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
    example: `H3A 0G4`,
    errorMessage: `Please enter a valid Canadian postal code.`,
  },
  GB: {
    pattern:
      /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) ?[0-9][A-Za-z]{2})$/,
    example: `B5 5JE`,
    errorMessage: `Please enter a valid British postcode.`,
  },
};

export function getPostalCodeError(postalCode: string, countryCode: string) {
  const format = postalCodeFormats[countryCode];
  if (format && !format.pattern.test(postalCode)) {
    return format.errorMessage;
  }
  return null;
}
